import React from "react";
import Seo from "components/Seo";
import TransportLayout from "./transportLayout";
import CenterImg from "assets/morning/center.png";
import IconCenterImg from "assets/morning/icon_center.png";

const MorningCenter = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="전국센터조직도" />
            <TransportLayout>
                <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-[0px] responsive1200:px-[4%]">
                    <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">
                        전국센터조직도
                    </p>
                    <div className="bg-white w-full max-w-[1200px] pt-[55px] px-[50px] pb-[60px] flex responsive1200:px-[4%] responsive1200:py-[10%] responsive1200:flex-col">
                        <img className="pt-3 w-full max-w-[600px] animate-fade-in mx-auto" src={CenterImg} alt="CenterImg" />
                        <div className="flex flex-col ml-[55px] w-full mt-5 responsive1200:ml-0">
                            <p className="text-[23px] text-[#333] font-semibold responsive1200:text-[20px]">일신모닝택배 전국 영업소</p>
                            <hr className="mt-[11px] mb-[5px] border-[1px] border-[#182746]" />
                            <div className="mt-[25px] mb-[20px] responsive1200:my-[16px]">
                                <div className="mb-[11px] text-[#182746] font-semibold flex gap-2">
                                    <img src={IconCenterImg} alt="CenterImg" />
                                    <p className="responsive1200:text-[15px]">서울지역 영업소</p>
                                </div>
                                <p className="text-[15px] text-[#333] leading-6 responsive1200:text-[14px]">
                                    강남, 강북, 강서, 명동, 안양, 과천, 중랑구, 광진구, 장안동, <br className="responsive1200:hidden" />
                                    성수동, 구로, 가산, 여의도, 영등포, 마포, 동대문 등
                                </p>
                            </div>
                            <hr />
                            <div className="mt-[25px] mb-[20px] responsive1200:my-[16px]">
                                <div className="mb-[11px] text-[#182746] font-semibold flex gap-2">
                                    <img src={IconCenterImg} alt="CenterImg" />
                                    <p className="responsive1200:text-[15px]">경기북부 영업소</p>
                                </div>
                                <p className="text-[15px] text-[#333] leading-6 responsive1200:text-[14px]">
                                    양주, 포천, 동두천, 연천, 의정부 등
                                </p>
                            </div>
                            <hr />
                            <div className="mt-[25px] mb-[20px] responsive1200:my-[16px]">
                                <div className="mb-[11px] text-[#182746] font-semibold flex gap-2">
                                    <img src={IconCenterImg} alt="CenterImg" />
                                    <p className="responsive1200:text-[15px]">동부 영업소</p>
                                </div>
                                <p className="text-[15px] text-[#333] leading-6 responsive1200:text-[14px]">
                                    송파, 강동, 하남, 성남, 구리, 남양주, 용인, 광주, 이천, 여주 등
                                </p>
                            </div>
                            <hr />
                            <div className="mt-[25px] mb-[20px] responsive1200:my-[16px]">
                                <div className="mb-[11px] text-[#182746] font-semibold flex gap-2">
                                    <img src={IconCenterImg} alt="CenterImg" />
                                    <p className="responsive1200:text-[15px]">남부 영업소</p>
                                </div>
                                <p className="text-[15px] text-[#333] leading-6 responsive1200:text-[14px]">
                                    안산, 시흥, 시화, 수원, 화성, 안성, 평택 등
                                </p>
                            </div>
                            <hr />
                            <div className="mt-[25px] mb-[20px] responsive1200:my-[16px]">
                                <div className="mb-[11px] text-[#182746] font-semibold flex gap-2">
                                    <img src={IconCenterImg} alt="CenterImg" />
                                    <p className="responsive1200:text-[15px]">서부 영업소</p>
                                </div>
                                <p className="text-[15px] text-[#333] leading-6 responsive1200:text-[14px]">부천, 부평, 인천, 김포 등</p>
                            </div>
                            <hr />
                            <div className="mt-[25px] mb-[20px] responsive1200:my-[16px]">
                                <div className="mb-[11px] text-[#182746] font-semibold flex gap-2">
                                    <img src={IconCenterImg} alt="CenterImg" />
                                    <p className="responsive1200:text-[15px]">대구/경북지역 영업소</p>
                                </div>
                                <p className="text-[15px] text-[#333] leading-6 responsive1200:text-[14px]">
                                    대구, 구미, 칠곡, 성주, 고령, 경산, 영천 등
                                </p>
                            </div>
                            <hr />
                            <div className="mt-[25px] mb-[20px] responsive1200:my-[16px]">
                                <div className="mb-[11px] text-[#182746] font-semibold flex gap-2">
                                    <img src={IconCenterImg} alt="CenterImg" />
                                    <p className="responsive1200:text-[15px]">부산 영업소</p>
                                </div>
                                <p className="text-[15px] text-[#333] leading-6 responsive1200:text-[14px]">부산, 경남 양산</p>
                            </div>
                        </div>
                    </div>
                </div>
            </TransportLayout>
        </React.Fragment>
    );
};

export default MorningCenter;
